import { apiInstance_ecom } from "@/app/api-config/axios-instance";
import { createQueryString } from "@/app/utils/utility";

export function getFlashSaleActiveData() {
  const response = apiInstance_ecom.get(`/flash-sale`);
  return response;
}
